import { Link, useLocation } from "react-router-dom";
import { useSeo } from "@/hooks/useSeo";

export default function NotFound() {
  const location = useLocation();

  useSeo({
    title: "页面未找到 - 风间由美官方网站",
    description: "抱歉，你访问的页面不存在或已被移除。可返回首页继续浏览风间由美的官方资讯与作品介绍。",
    keywords: "风间由美,页面未找到,404",
  });

  return (
    <div className="mx-auto flex min-h-[70vh] w-full max-w-[1320px] flex-col items-center justify-center px-4 py-24 text-center md:px-6">
      <span className="font-heading text-6xl font-bold text-primary-200 md:text-8xl">404</span>
      <h1 className="mt-4 font-heading text-2xl font-bold text-foreground-950">
        没有找到这个页面
      </h1>
      <p className="mt-3 max-w-md text-sm text-foreground-600">
        页面可能已被移除或链接有误。你可以返回首页，或继续浏览新闻资讯与作品介绍。
      </p>
      <p className="mt-2 font-mono text-xs text-foreground-400">{location.pathname}</p>
      <div className="mt-7 flex flex-col gap-3 sm:flex-row">
        <Link
          to="/"
          className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
        >
          <i className="ri-home-4-line" />
          返回首页
        </Link>
        <Link
          to="/news"
          className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm font-semibold text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-600"
        >
          浏览新闻资讯
        </Link>
      </div>
    </div>
  );
}